import styled from 'styled-components';

interface StackedProps {
    stacked?: boolean;
}

export const CreditRatingContainer = styled.div<StackedProps>`
    display: flex;
    flex-direction: ${({ stacked }) => (stacked ? 'column' : 'row')};
    align-items: ${({ stacked }) => (stacked ? 'flex-start' : 'center')};
    gap: ${({ stacked }) => (stacked ? '4px' : '1rem')};
`;

export const RadioButtonContainer = styled.div<StackedProps>`
    display: flex;
    flex-direction: ${({ stacked }) => (stacked ? 'column' : 'row')};
    align-items: ${({ stacked }) => (stacked ? 'flex-start' : 'center')};
    gap: ${({ stacked }) => (stacked ? '14px' : '0')};
    flex: ${({ stacked }) => (stacked ? 'none' : '1')};
    flex-shrink: ${({ stacked }) => (stacked ? '0' : 'unset')};

    & .MuiFormGroup-root {
        width: 100%;
        gap: 45px;
    }

    & .MuiInputLabel-root.MuiInputLabel-root {
        font-size: ${({ stacked }) => (stacked ? '12px' : 'inherit')};
    }

    & .MuiRadio-root {
        width: ${({ stacked }) => (stacked ? '20px' : 'unset')};
        height: ${({ stacked }) => (stacked ? '20px' : 'unset')};
    }
`;

export const InputWrapper = styled.div<StackedProps>`
    display: flex;
    flex-direction: ${({ stacked }) => (stacked ? 'column' : 'row')};
    align-items: ${({ stacked }) => (stacked ? 'flex-start' : 'center')};
    gap: ${({ stacked }) => (stacked ? '4px' : '0')};
    align-self: ${({ stacked }) => (stacked ? 'stretch' : 'auto')};
    flex: ${({ stacked }) => (stacked ? 'none' : '1')};
`;
